import { SHA256, enc } from "crypto-js";
import { CLIENT_ID, SI_API_ENDPOINT } from "./constants";

// NOTE: This function based on https://github.com/ricoh/sdca/blob/master/apps/help-page/app.js#L60
export function doAuthorization(redirectUri: string) {
  const setting = {
    authorizeUri: `${SI_API_ENDPOINT}/v1/aut/oauth/provider/authorize`,
    clientId: CLIENT_ID,
  };
  // The following code tries to get RSI OAuth access token to generate a RICOH support account.
  // The OAuth client is created at sidemo tenant.
  // Please see https://www.devu.smart-integration.ricoh.com/system-site/clientapp/70ceWCOSL9bUCaSQcWVEUWBVdhJ8HpAD/edit
  //
  // References:
  // - API doc:         https://share.dev.smart-integration.ricoh.com/public/api/authentication/oauth-provider.en.html
  // - RSI OAuth scope: https://share.dev.smart-integration.ricoh.com/public/api/cloud-common.en.html#oauth-scope
  // - OAuth PKCE:      https://tools.ietf.org/html/rfc7636.html
  const state = makeRandomString(
    32,
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
  );
  const verifier = makeRandomString(
    128,
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~",
  );
  const challenge = createCodeChallenge(verifier);
  const scope = ["aut:user:admin", "io:job:admin", "sem:license:read", "aut:bulk:admin"].join(
    " ",
  );
  const url =
    setting.authorizeUri +
    "?response_type=code&code_challenge_method=S256&response_mode=fragment" +
    "&client_id=" +
    setting.clientId +
    "&redirect_uri=" +
    redirectUri +
    "&scope=" +
    scope +
    "&state=" +
    state +
    "&code_challenge=" +
    challenge;
  sessionStorage.setItem("state", state);
  sessionStorage.setItem("verifier", verifier);
  window.location.href = url;
}

export function ckeckAccessTokenExpire(localStorageAccessToken: string | null) {
  if (!localStorageAccessToken) {
    throw Error("Please re-login");
  }
  const accessTokenObject = JSON.parse(localStorageAccessToken);
  if (accessTokenObject.expire - new Date().getTime() < 30 * 60 * 1000) {
    throw Error("Expired access token. Please re-login");
  }
  return accessTokenObject.value;
}

function makeRandomString(length: Number, possible: string) {
  const chars = [];
  for (var i = 0; i < length; i++) {
    chars.push(possible.charAt(Math.floor(Math.random() * possible.length)));
  }
  return chars.join("");
}

function createCodeChallenge(verifier: string) {
  const hashInBase64 = enc.Base64.stringify(SHA256(verifier));
  const challenge = hashInBase64.replace(/\+/g, "-").replace(/\//g, "_");
  return challenge.substr(0, challenge.length - 1);
}
